import { render, staticRenderFns } from "./buscaPaciente.vue?vue&type=template&id=3bee87bb&"
import script from "./buscaPaciente.vue?vue&type=script&lang=js&"
export * from "./buscaPaciente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports